module.exports = "/packs/images/homepage/facilities/healthier-communities~35a8bc3fca8ad9bce1491e3fb03c2aad.jpg";